export const BASE_INCOME = {
  income_type: undefined,
  monthly_amount: {
    amount: undefined,
    currency: 'GBP',
  },
};

export const INCOME_BUTTON_LABEL = 'Add new source of income';

export const INCOME_PROPS = {
  name: 'monthly_amount.amount',
  type: 'price',
  icon: 'pound',
  iconVariant: 'dark',
  symbol: '',
  label: 'Monthly amount',
  placeholder: 'The monthly income for this source',
  validation: {
    required: {
      value: true,
      message: 'You must provide the income amount',
    },
    min: { value: 1, message: 'Amount must be great than £0.01' },
  },
};

export const INCOME_OPTIONS = [
  { name: 'Benefits', value: 'benefits' },
  { name: 'Pensions', value: 'pensions' },
  {
    name: 'Other Sources Of Income',
    value: 'other_sources_of_income',
  },
];

export const INCOME_SELECT_PROPS = {
  placeholder: 'Select...',
  label: 'Income Type',
  options: INCOME_OPTIONS,
  validation: {
    required: {
      value: true,
      message: 'You must select an income type',
    },
  },
};
